"use client";

import ProductCard from "@/components/custom/product-card";
import { parseAsString, useQueryState } from "nuqs";
import type { Product } from "@/lib/data";

type ProductWithCategory = Product & {
  readonly category: string;
  readonly purchaseDescriptionFromItems?: string;
  readonly nameFromItems?: string;
  readonly shortDescriptionFromItems?: string;
};

type ProductsContentProps = {
  readonly products: readonly ProductWithCategory[];
  readonly category: string;
};

export default function ProductsContent({
  products,
  category,
}: ProductsContentProps) {
  const [query] = useQueryState("query", parseAsString.withDefault(""));

  const filteredProducts = products.filter((product) => {
    const productName = product.nameFromItems ?? product.name ?? "";
    return productName.toLowerCase().includes(query?.toLowerCase() ?? "");
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8 mb-8">
      {filteredProducts.map((product, i) => {
        const description =
          product.shortDescriptionFromItems ??
          product.purchaseDescriptionFromItems ??
          product.description ??
          product.purchase_description ??
          "";

        const productName = product.nameFromItems ?? product.name ?? "";

        return (
          <ProductCard
            category={category}
            code={product.sku ?? product.item_id ?? ""}
            key={`${product.sku ?? product.item_id ?? ""}-${i}`}
            name={productName}
            description={description}
          />
        );
      })}
    </div>
  );
}
